export const parseConst = (schema) => {
    return `z.literal(${JSON.stringify(schema.const)})`;
};
